// TODO: refactor this file
import React, { useCallback, useMemo } from "react"
import {
  Box,
  Slide,
  useMediaQuery,
  styled,
  Button,
  useTheme,
} from "@mui/material"
import { useNavigate, useMatch } from "react-router-dom"
import { FeatureDetail } from "components/domains/features/Detail"
import { TopBarContainer } from "containers/TopBarContainer"
import { KeyboardBackspaceIcon } from "components/icons"
import { Head } from "components/Head"
import { useTranslation } from "providers/i18n"
import { useAppUI } from "providers/ui"
import { useFeatureDetail } from "hooks/feature/useFeatureDetail"
import { useVenue } from "providers/venue"
import { KioskFeatureDialog } from "components/domains/features"
import config from "config"
import { FeatureListDetail } from "extensions/em-core/components/FeatureListDetail"
import SwipeableDrawer from "extensions/em-core/components/SwipeableDrawer"
import { FeatureSummary } from "extensions/em-core/components/domains/features/FeatureSummary"
import { DesktopFeatureDialog } from "extensions/em-core/components/DesktopFeatureDialog"

const DRAWER_BLEEDING = 220
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />
})

const StyledButton = styled(Button)(({ theme }) => ({
  background: theme.palette.common.white,
  minWidth: "unset",
  borderRadius: "50%",
  padding: theme.spacing(1.5),
  boxShadow: theme.shadows[15],
  zIndex: 1300,
  "&:hover": {
    background: theme.palette.grey[200],
  },
}))

const Wrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  background: theme.palette.common.white,
}))

const ContentWrapper = styled(Wrapper)(({ theme }) => ({
  boxShadow: "none",
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(1.25),
  },
  pointerEvents: "auto",
}))

const ContentListWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0),
  background: theme.palette.common.white,
  boxShadow: "none",
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(1.25),
  },
  pointerEvents: "auto",
}))

// TODO: add box-shadow to BleedWrapper
const BleedWrapper = styled(Wrapper)(({ theme }) => ({
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  paddingTop: theme.spacing(5.25),
  paddingBottom: theme.spacing(2),
}))

export const PlaceDetailPage = ({ DirectionButtonProps, BackButtonProps }) => {
  const { dataLoaded, ...data } = useFeatureDetail()

  const {
    feature,
    zone,
    logo,
    venueLogo,
    category,
    level,
    name,
    hours,
    id,
    website,
    gallery,
    promotions,
    privileges,
    description,
    group,
    relatedOccupants,
    venueName,
    categoryIconPath: categoryIcon,
  } = data

  const { isMultiOrdinalVenue, isMultiVenueProject } = useVenue()
  const { goBack } = useAppUI()

  const match = useMatch(`/maps/place/:placeId`)
  const navigate = useNavigate()
  const onNavigate = useCallback(() => {
    const locationId = feature?.properties?.feature?.id || id
    navigate(`/maps/dir/unknown/${locationId}`, {
      state: {
        prevDestinationId: id,
      },
    })
  }, [navigate, feature, id])
  const isMobile = useMediaQuery("(max-width: 767px)")
  const device = config("device") || "mobile"

  const { t } = useTranslation()
  const handleClickBack = useCallback(() => {
    goBack()
  }, [goBack])

  const onClose = useCallback(() => {
    goBack()
  }, [goBack])

  const theme = useTheme()

  const drawerBleeding = useMemo(() => {
    const screenHeight = window.innerHeight
    const heightFactor = theme.mixins?.drawerBleeding?.heightFactor

    if (heightFactor > 0 && heightFactor < 1) {
      return screenHeight * heightFactor
    }

    return DRAWER_BLEEDING
  }, [theme.mixins?.drawerBleeding?.heightFactor])

  const {
    icon = (
      <KeyboardBackspaceIcon sx={{ width: 20, height: 20 }} color="primary" />
    ),
  } = BackButtonProps || {}

  const isSection = feature?.feature_type === "section"

  const open = !!match

  if (!open) return null
  return (
    <>
      <Head title={`${t(name)} (${t("Place Detail")})`} />
      {isMobile ? (
        <Box>
          <TopBarContainer>
            <StyledButton variant="contained" onClick={handleClickBack}>
              {icon}
            </StyledButton>
          </TopBarContainer>
          <SwipeableDrawer key={drawerBleeding} drawerBleeding={drawerBleeding}>
            <BleedWrapper>
              <FeatureSummary
                id={id}
                name={name}
                hours={hours}
                level={isMultiOrdinalVenue && level}
                category={category}
                categoryIcon={categoryIcon}
                logo={logo}
                venueLogo={isMultiVenueProject && venueLogo}
                venueName={venueName}
                zone={zone}
                group={group}
                onNavigate={onNavigate}
                DirectionButtonProps={DirectionButtonProps}
                loading={!dataLoaded}
              />
            </BleedWrapper>
            {isSection ? (
              <ContentListWrapper>
                <FeatureListDetail
                  list={relatedOccupants}
                  loading={!dataLoaded}
                />
              </ContentListWrapper>
            ) : (
              <ContentWrapper>
                <FeatureDetail
                  feature={feature}
                  website={website}
                  gallery={gallery}
                  promotions={promotions}
                  privileges={privileges}
                  description={description}
                  loading={!dataLoaded}
                />
              </ContentWrapper>
            )}
          </SwipeableDrawer>
        </Box>
      ) : //TODO:: Temporary solution for preventing the tourist friendly theme shows unexpected ui
      device === "mobile" ? (
        // Desktop Viewport
        <>
          <TopBarContainer>
            <StyledButton variant="contained" onClick={handleClickBack}>
              {icon}
            </StyledButton>
          </TopBarContainer>
          <DesktopFeatureDialog
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            /* Allow user to click behind modal */
            hideBackdrop
            anchor="left"
            disableEnforceFocus
            onNavigate={onNavigate}
            /* End of Allow user to click behind modal */
            directionButtonProps={DirectionButtonProps}
            isMultiOrdinalVenue={isMultiOrdinalVenue}
            loading={!dataLoaded}
            data={data}
          />
        </>
      ) : (
        // Kiosk Viewport
        <KioskFeatureDialog
          open={open}
          onClose={onClose}
          TransitionComponent={Transition}
          TransitionProps={{
            direction: "up",
          }}
          /* Allow user to click behind modal */
          hideBackdrop
          anchor="bottom"
          disableEnforceFocus
          /* End of Allow user to click behind modal */
          loading={!dataLoaded}
          data={data}
          onNavigate={onNavigate}
        />
      )}
    </>
  )
}
